<template>
  <header class="page-header">
    <section class="page-header__hgroup -no-bread">
      <h1 v-appear:right="{ delay: [$scroll, 750] }" class="page-header__title">
        {{ $t('common.navigation.eventsAnnual') }}
      </h1>

      <p v-appear="{ delay: [$scroll, 825, 125] }">{{ $t('events.header') }}</p>
    </section>
  </header>
</template>

<script>
export default {
  name: 'EventsHeader'
}
</script>
